import SetUpPwlTitle from "./SetUpPwlTitle";
import SelectUnlockMethod from "./SelectUnlockMethod";

const setupPwlComponents = {
  SetUpPwlTitle,
  SelectUnlockMethod
}

export default setupPwlComponents;